const AI_ASSISTANT_CONSTANTS = {
  FETCH_RESPONSE: 'FETCH_RESPONSE',
  GET_CHAT_SUMMARY: 'GET_CHAT_SUMMARY',
  SET_CHAT_SUMMARY_R: 'SET_CHAT_SUMMARY_R',
  SET_CHAT_SUMMARY_Q: 'SET_CHAT_SUMMARY_Q',
  SET_ERROR_INFO: 'SET_ERROR_INFO',
  SET_LOADING: 'SET_LOADING',
  DEFAULT_ERR_MSG: 'No response found, please update your query.'
};

export default AI_ASSISTANT_CONSTANTS;
